import { Avatar, Box, Chip, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, Theme, Typography, createStyles, makeStyles, withStyles } from "@material-ui/core";
import Skeleton from '@material-ui/lab/Skeleton';
import { FC, useContext, useState } from "react";
import Moment from "react-moment";
import { useHistory } from "react-router";

import { Colors } from "../../helpers/theme";
import { USDollar } from "../../utils/currency/usd";

import PoolContext from "../../store/Pool/PoolContext";
import { getNetworkBadge } from "../../utils/web3/getNetworkBadge";

const useStyles = makeStyles({
    tablehead: {
        "& .MuiTableBody-root": {
          display: "block",
        },
        "& .MuiTableRow-root": {
          borderBottom: "1px solid rgba(76, 100, 97, 0.1)",
          verticalAlign: "baseline",
          width: "100%",
        //   display: "inherit",
          padding: "0px",
        },
        "& .MuiTypography-body1": {
          color: Colors.greySlate,
        },
        "& .MuiTableCell-root": {
          "&:first-child": {
            width: "25%",
          },
          "&:nth-child(2)": {
            width: "25%",
          },
          "&:nth-child(3)": {
            width: "20%",
          },
          "&:nth-child(4)": {
            width: "15%",
          },
          "&:nth-child(5)": {
            width: "15%",
          },
        },
    },
    logo: {
        width: 40,
        height: 40,
        mixBlendMode: "normal",
        border: "3px solid #FFFFFF",
        borderRadius: "100px",
        filter: "drop-shadow(0px 4px 15px rgba(0, 0, 0, 0.1))",
        backgroundColor: Colors.white,
    },
    projectDetail: {
        marginLeft: "15px"
    },
    projectHeading: {
        fontSize: "16px",
        color: Colors.greenDark,
    },
    projectTicker: {
        color: Colors.blackLight,
        fontWeight: 200,
        fontSize: "14px",
    },
    network: {
        width: 30,
        height: 30,
    },
    pageNumber: {
        display: "inline-flex",
        width: 30,
        height: 30,
        color: Colors.greySlate,
        fontWeight: 400,
        fontSize: "12px",
        border: "1px solid " + Colors.lightWhite,
        borderRadius: "8px",
        justifyContent: "center",
        alignItems: "center",
        margin: "5px",
        cursor: "pointer",
    },
    activePage: {
        backgroundColor: Colors.loadingBlue,
        color: Colors.white,
    },
    skeleton: {
        opacity: 0.8,
        borderRadius: "15px",
        boxShadow: "none",
        '&:nth-of-type(odd)': {
            backgroundColor: Colors.darkWhite,
        },
        '&:hover': {
            backgroundColor: Colors.secondaryWhite,
            cursor: 'pointer',
        },
    },
})

const StyledTableCell = withStyles((theme: Theme) => createStyles({
    body: {
        color: Colors.darkSlate,
        fontSize: "14px",
        fontWeight: 700,
        boxShadow: "none",
        "&:nth-child(1)": {
            width: "25%", // Set the width for the first column
        },
        "&:nth-child(2)": {
            width: "25%", // Set the width for the second column
        },
        "&:nth-child(3)": {
            width: "20%", // Set the width for the third column
        },
        "&:nth-child(4)": {
            width: "15%", // Set the width for the fourth column
        },
        "&:nth-child(5)": {
            width: "15%", // Set the width for the fifth column
        },
    }
}))(TableCell);

const StyledTableRow = withStyles((theme: Theme) =>
  createStyles({
    root: {
        width: "100%",
        padding: 0,
        opacity: 0.8,
        borderRadius: "15px",
        boxShadow: "none",
        transition: "background-color 0.3s ease, transform 0.3s ease",
        willChange: "transform",
        '&:nth-of-type(odd)': {
            backgroundColor: Colors.darkWhite,
        },
        '&:nth-of-type(even)': {
          backgroundColor: Colors.white,
        },
        '&:hover': {
            backgroundColor: Colors.secondaryWhite,
            cursor: 'pointer',
            transform: "scale(1.02)",
        },
    },
  }),
)(TableRow);

// TODO: Define types
const ClosedPoolsDesktopView: FC<any> = () => {

    const classes = useStyles();
    const history = useHistory();

    const {  closedPoolsPaginated: endedPools, setActivePool, fetchPage, totalClosedPools, isClosedPoolsLoading, closedPoolsError } = useContext<any>(PoolContext);

    const [page, setPage] = useState(0);
    const rowsPerPage = 10;
    const emptyArray = Array(rowsPerPage).fill({});

    const handleClickPage = (pageNum: number) => {
        fetchPage(pageNum + 1);
        setPage(pageNum);
    };

    const handleClick = (props: {id: string, networks: any, name: string, slug?: string}) => {
        const {slug, id} = props
        setActivePool(props);
        let urlId;
        if(slug){
            urlId = slug;
        }else{
            urlId = id;
        }
        history.push(`/project/${urlId}`);
    };

    return (
        <>
            <Table className={classes.tablehead} aria-label="closed pools funded projects">
                <TableBody>
                    <TableRow>
                        <TableCell className="" align="left">
                            <Typography
                                component="span"
                                variant="subtitle1"
                                className="fw-bold"
                            >
                                Project
                            </Typography>
                        </TableCell>
                        <TableCell className="" align="right">
                            <Typography
                                component="span"
                                variant="subtitle1"
                                className="fw-bold"
                            >
                                Ended On
                            </Typography>
                        </TableCell>
                        <TableCell className="" align="center">
                            <Typography
                                component="span"
                                variant="subtitle1"
                                className="fw-bold"
                            >
                                Total Raised
                            </Typography>
                        </TableCell>
                        <TableCell className="" align="right">
                            <Typography
                                component="span"
                                variant="subtitle1"
                                className="fw-bold"
                            >
                                ATH ROI
                            </Typography>
                        </TableCell>
                        <TableCell className="" align="right">
                            <Typography
                                component="span"
                                variant="subtitle1"
                                className="fw-bold"
                            >                                
                                Chain
                            </Typography>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
            <Table>
                <TableBody>
                    {
                        isClosedPoolsLoading && (
                            emptyArray.map((i: number) => (
                                <>
                                    <StyledTableRow key={0}>
                                        <Skeleton 
                                        variant="rect" 
                                        height={80}
                                        animation="pulse"
                                        className={classes.skeleton}
                                        />
                                    </StyledTableRow>
                                </>
                            ))
                            
                        )
                    }
                    <TableRow>
                        <TableCell
                            style={{
                                paddingLeft: "0",
                                paddingRight: "0",
                                paddingBottom: "0",
                            }}
                        >
                            <>
                                {
                                    (!isClosedPoolsLoading) && 
                                    endedPools
                                    .map((pool: any) => (
                                        <StyledTableRow key={pool.id} onClick={() => handleClick({id: pool.id, networks: pool.networks, name: pool.name, slug: pool.slug})}>
                                            <StyledTableCell component="th" scope="row">
                                                <Box
                                                    display="flex"
                                                    flexDirection="row"
                                                    alignItems="start"
                                                >
                                                    <img src={pool?.image} alt="Project Image" className={classes.logo} />
                                                    <Box
                                                        display="flex"
                                                        flexDirection="column"
                                                        className={classes.projectDetail}
                                                    >
                                                        <Typography component="span" variant="h4" 
                                                        className={classes.projectHeading}
                                                        >
                                                            {pool?.name}
                                                        </Typography>
                                                        <Typography
                                                        component="span"
                                                        variant="subtitle1"
                                                        className={classes.projectTicker}
                                                        >
                                                            {`$${pool?.ticker?.toUpperCase()}`}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </StyledTableCell >
                                            <StyledTableCell align="right">
                                                <Moment format="DD/MM/YYYY">
                                                    {pool?.contributionEndDate}
                                                </Moment>
                                            </StyledTableCell>
                                            <StyledTableCell align="center">
                                                {`${USDollar.format(pool?.totalRaised)}`}
                                            </StyledTableCell>
                                            <StyledTableCell align="right">
                                            {(pool?.ath) ? parseFloat(((pool?.ath) / pool?.poolTokenPrice).toFixed(1)) + "x" : "NA"}
                                            </StyledTableCell>
                                            <StyledTableCell align="right">
                                                <Box
                                                    display="flex"
                                                    justifyContent="end"
                                                >
                                                    {
                                                        pool.distributionScAddress && pool.distributionScAddress.length > 0 && (
                                                        <>
                                                            {
                                                            getNetworkBadge(pool.distributionScAddress[0].chain) 
                                                            ? (
                                                                <Avatar
                                                                alt="Network"
                                                                src={getNetworkBadge(pool.distributionScAddress[0].chain)}
                                                                className={classes.network}
                                                                />
                                                            ) : (
                                                                <>
                                                                    <Chip className="fw-bold" color="primary" label={pool.distributionScAddress[0].chain} />
                                                                </>
                                                            )
                                                            }
                                                        </>
                                                        )
                                                    }
                                                </Box>
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    ))
                                }
                            </>
                        </TableCell>
                    </TableRow>
                </TableBody>
                {
                    totalClosedPools > rowsPerPage && (
                        <TableFooter>
                            {
                                <TableRow
                                    style={{
                                        boxShadow: "none",
                                    }}
                                >
                                    <TableCell 
                                        colSpan={5} 
                                        align="center">
                                        <div>
                                            {/* Render the expandable middle section with page numbers */}
                                            {Array.from(Array(Math.ceil(totalClosedPools / rowsPerPage)).keys()).map((pageNum) => (
                                                <div
                                                key={pageNum}
                                                className={`${classes.pageNumber} ${ pageNum === page ? classes.activePage : ''}`}
                                                onClick={() => handleClickPage(pageNum)}
                                                >
                                                {pageNum + 1}
                                                </div>
                                            ))}
                                        </div>
                                    </TableCell>
                                </TableRow>
                            }
                        </TableFooter>
                    )
                }
            </Table>
        </>
    )
}

export default ClosedPoolsDesktopView